import "../App.css";
import NavBar from "./NavBar";
import PostContainer from "./PostContainer";

function App() {
  return (
    <>
      <NavBar />
      <PostContainer />
    </>
  );
}

export default App;

// NavBar

// PostContainer
// AddPost
// Post
// PostAction

// Button
// Avatar
// Logo
// Footer
// Sidebar
